// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner__3a1jb","description":"description__4jtzX","bannerButton":"bannerButton__2wfFr","dontShowAgain":"dontShowAgain__18iAx"};